import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/buttons';
import { useTranslation } from 'react-i18next';
interface Props {
  handleSubmit: () => Promise<void>;
  disabled: boolean;
}
export function ReturnToLimit(t0) {
  const $ = _c(13);
  const {
    handleSubmit,
    disabled
  } = t0;
  const {
    t
  } = useTranslation("overpayRefund");
  let t1;
  if ($[0] !== t) {
    t1 = t("refundToMaxi.text");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="text-left text-lg">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("refundToMaxi.button");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== disabled || $[7] !== handleSubmit || $[8] !== t3) {
    t4 = <div className="flex justify-center"><Button variant="primary" analyticsParam="refundToMaxi" testId="refundToMaxi" onClick={handleSubmit} disabled={disabled}>{t3}</Button></div>;
    $[6] = disabled;
    $[7] = handleSubmit;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <div className="flex flex-col gap-4 lg:gap-10">{t2}{t4}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}